import { t } from '../../../locales';
import { featureFlag } from '../../entities/feature-flag';

const socialMentionsRoutes = {
	path: 'social-mentions',
	component: () => import('./module-layout.vue'),
	meta: {
		featureFlag: featureFlag.VERIFY_SY, // currently only verify sy is enabled
	},
	children: [
		{
			path: '',
			redirect: '/v2/social-mentions/mentions',
		},
		{
			path: 'mentions',
			component: () => import('./pages/mentions/index.vue'),
			meta: {
				title: t('social-mentions.titles.mentions'),
			},
		},
		{
			path: 'mentions/:id',
			component: () => import('./pages/mentions/details.vue'),
			meta: {
				title: t('social-mentions.titles.mentionDetails'),
			},
		},
		{
			path: 'threads',
			component: () => import('./pages/threads/index.vue'),
			meta: {
				title: t('social-mentions.titles.threads'),
			},
		},
		{
			path: 'threads/:id',
			component: () => import('./pages/threads/details.vue'),
			meta: {
				title: t('social-mentions.titles.threadDetails'),
			},
		},
		{
			path: 'users',
			component: () => import('./pages/users/index.vue'),
			meta: {
				title: t('social-mentions.titles.users'),
			},
		},
		{
			path: 'users/:id',
			component: () => import('./pages/users/details.vue'),
			meta: {
				title: t('social-mentions.titles.userDetails'),
			},
		},
		{
			path: 'stats',
			component: () => import('./pages/stats/index.vue'),
			meta: {
				title: t('social-mentions.titles.stats'),
			},
		},
		{
			path: 'config',
			component: () => import('./pages/config/index.vue'),
			meta: {
				title: t('social-mentions.titles.config'),
			},
		},
	],
};

export { socialMentionsRoutes };
